var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-page-layout"},[_c('div',{staticClass:"filter-wrapper"},[_vm._t("filter")],2),_c('div',{staticClass:"title-wrapper"},[_vm._t("title")],2),_c('div',{staticClass:"content-wrapper",attrs:{"id":"contentWrapper"}},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }